module.exports = __webpack_public_path__ + "img/command.ebc119eb.png";